module.exports = __webpack_public_path__ + "img/work3.4cec1f77.png";